import styled from 'styled-components';
import { Text } from '@make-software/tg-mini-app-ui';

export const StyledBodyText = styled(Text)(({ theme }) =>
  theme.withMedia({
    display: 'block',
    fontWeight: '700',
    margin: '24px 0 16px 0',
    fontFamily: 'Inter',
    span: {
      fontSize: '12px',
      color: '#84858C',
      marginRight: '4px',
      fontWeight: '300'
    }
  })
);
